import React, { useState, useEffect } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

export default function VanSalesHistogram() {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [yearsBack, setYearsBack] = useState(1)

  useEffect(() => {
    setLoading(true)
    fetch(`/api/metrics/van_sales_histogram?years=${yearsBack}`)
      .then(response => {
        if (!response.ok) throw new Error('Failed to fetch histogram data')
        return response.json()
      })
      .then(data => {
        setData(data)
        setLoading(false)
      })
      .catch(err => {
        setError(err.message)
        setLoading(false)
      })
  }, [yearsBack])

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-gray-500">Loading...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-red-500">Error: {error}</div>
      </div>
    )
  }

  const chartOptions = {
    chart: {
      type: 'column',
      height: 500
    },
    title: {
      text: 'Van Sales by Month'
    },
    xAxis: {
      categories: data.map(d => d.month_label),
      title: {
        text: 'Month'
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Number of Vans Sold'
      },
      allowDecimals: false
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
          format: '{y}'
        }
      }
    },
    series: [{
      name: 'Vans Sold',
      data: data.map(d => d.value),
      color: '#3b82f6'
    }],
    legend: {
      enabled: false
    },
    credits: {
      enabled: false
    },
    tooltip: {
      formatter: function() {
        return `<b>${this.x}</b><br/>Vans Sold: ${this.y}`
      }
    }
  }

  return (
    <div className="px-4 sm:px-0">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Van Sales by Month</h1>

        {/* Time Period Selector */}
        <div className="flex items-center space-x-4">
          <label className="text-sm font-medium text-gray-700">Time Period:</label>
          <div className="flex space-x-2">
            <button
              onClick={() => setYearsBack(1)}
              className={`px-4 py-2 text-sm font-medium rounded-md ${
                yearsBack === 1
                  ? 'bg-gray-900 text-white'
                  : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
              }`}
            >
              Last 1 Year
            </button>
            <button
              onClick={() => setYearsBack(2)}
              className={`px-4 py-2 text-sm font-medium rounded-md ${
                yearsBack === 2
                  ? 'bg-gray-900 text-white'
                  : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
              }`}
            >
              Last 2 Years
            </button>
            <button
              onClick={() => setYearsBack(3)}
              className={`px-4 py-2 text-sm font-medium rounded-md ${
                yearsBack === 3
                  ? 'bg-gray-900 text-white'
                  : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
              }`}
            >
              Last 3 Years
            </button>
          </div>
        </div>
      </div>

      {/* Chart */}
      <div className="bg-white p-6 rounded-lg shadow">
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      </div>
    </div>
  )
}
